import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { useAssistant } from "./AssistantContext";

const cleanName = (t) => {
  const w = String(t).replace(/[^\p{L}' -]/gu, " ").trim().split(/\s+/).slice(0, 3).join(" ");
  return w ? w[0].toUpperCase() + w.slice(1) : "";
};
export const introText = (n) => `Olá! Eu sou a ${n}, sua assistente da DPdigi. Sempre que precisar, é só me chamar pelo nome. Como posso ajudar?`;

// First access: a single written step — name the assistant or choose manual filling (never blocks the portal).
export function AssistantOnboarding() {
  const a = useAssistant();
  const { user, can, isCompanyUser, reload } = useAuth();
  const show = !!a && isCompanyUser && can("requests.create") && !user?.assistant?.onboarded;
  const [nm, setNm] = useState("");
  const [saving, setSaving] = useState(false);
  if (!show) return null;
  const n = cleanName(nm);
  const save = async (patch) => {
    setSaving(true);
    try {
      await api.put("/voice/profile", patch);
      await reload();
      if (patch.name) a.announce(introText(patch.name));
    } catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };
  const manual = () => save({ onboarded: true, enabled: false });
  const go = (e) => { e.preventDefault(); if (n) save({ name: n, onboarded: true, enabled: true }); };
  return (
    <Dialog open onOpenChange={(o) => !o && manual()}>
      <DialogContent className="max-w-md" data-testid="assistant-onboarding">
        <form onSubmit={go} className="space-y-4">
          <DialogHeader>
            <DialogTitle className="font-display text-xl" data-testid="assistant-onboarding-title">Como você gostaria de chamar sua assistente de IA?</DialogTitle>
            <DialogDescription className="text-sm leading-relaxed text-slate-600" data-testid="assistant-onboarding-text">
              Ela ajuda a preencher admissões, férias, desligamentos e outras solicitações por voz. É opcional: você pode ativar ou desativar quando quiser em Configurações.
            </DialogDescription>
          </DialogHeader>
          <Input autoFocus value={nm} maxLength={30} onChange={(e) => setNm(e.target.value)} placeholder="Digite o nome da sua assistente" data-testid="assistant-onboarding-name" />
          <DialogFooter className="gap-2">
            <Button type="button" variant="outline" onClick={manual} disabled={saving} data-testid="assistant-onboarding-manual">Prefiro preencher manualmente</Button>
            <Button type="submit" disabled={saving || !n} data-testid="assistant-onboarding-continue">Continuar</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>);
}
